import { useAppSelector } from "core/store/hooks";
import { generalLoaderSelector } from "core/store/selectors";
import "./style.scss";

const AppLoader: React.FC = () => {
	const loaderSelector = useAppSelector(generalLoaderSelector);

	if (!loaderSelector) return null;

	return (
		<div className="app-loader">
			<span className="loading loading-spinner loading-lg text-white" />
		</div>
	);
};
export default AppLoader;
